import { AiFeatures } from './AiFeatures';
import { aiSettingsSource, blipAccountIssuer, messagingHubDomain, blipDomainUrl, messaginghubWebsocketHostName, messaginghubWebsocketHostNameTenant, messaginghubWebsocketPort, messaginghubWebsocketScheme, } from 'app.constants';
export class AiController {
    static $inject = ['$stateParams', '$scope', '$sce', 'LoadingService', 'AI_FRAME_URL', 'AI_IS_MFE_ENABLED', '$location', 'DEFAULT_FRAGMENT_PREFIX', 'application', 'TenantService', 'TranslateService', 'AccountService2'];
    constructor($stateParams, $scope, $sce, LoadingService, AI_FRAME_URL, AI_IS_MFE_ENABLED, $location, DEFAULT_FRAGMENT_PREFIX, application, TenantService, TranslateService, AccountService2) {
        'ngInject';
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$sce = $sce;
        this.LoadingService = LoadingService;
        this.AI_FRAME_URL = AI_FRAME_URL;
        this.AI_IS_MFE_ENABLED = AI_IS_MFE_ENABLED;
        this.$location = $location;
        this.DEFAULT_FRAGMENT_PREFIX = DEFAULT_FRAGMENT_PREFIX;
        this.application = application;
        this.TenantService = TenantService;
        this.TranslateService = TranslateService;
        this.AccountService2 = AccountService2;
        this.settingsSource = aiSettingsSource;
    }
    async $onInit() {
        this.user = await this.getUserCopy();
        this.language = this.TranslateService.getCurrentLanguage();
        const { shortName, accessKey } = this.application;
        this.applicationData = { shortName, accessKey };
        this.messagingHubConfigurations = {
            domainUrl: blipDomainUrl,
            domain: messagingHubDomain,
            accountIssuer: blipAccountIssuer,
            websocketPort: messaginghubWebsocketPort,
            websocketScheme: messaginghubWebsocketScheme,
            websocketHostname: messaginghubWebsocketHostName,
            websocketHostnameTenant: messaginghubWebsocketHostNameTenant,
        };
        this.isReactViewEnabled = await AiFeatures.isMicrofrontAiReactEnabled();
        this.listEnabledReactPages = await AiFeatures.getReactPagesList();
        if (!this.isCurrentPathAvailableInMFE) {
            this.LoadingService.startLoading();
        }
        const params = this.$stateParams.path
            ? `${this.$stateParams.path.replace(/&/g, '/')}`
            : '';
        const aiFrameUrl = this.application.tenantId // To fix cases where a proxy is needed for debugging
            ? this.TenantService.addTenantPrefixToUrl(this.AI_FRAME_URL, this.application.tenantId)
            : this.TenantService.addTenantPrefixToUrl(this.DEFAULT_FRAGMENT_PREFIX, this.application.tenantId);
        this.frameUrl = this.$sce.trustAsResourceUrl(`${aiFrameUrl}${params}`);
        this.errorMessage =
            'Error while loading Artificial Intelligence module. Refresh the page or try again later';
        this.$scope.$on('$destroy', this.LoadingService.stopLoading);
    }
    async getUserCopy() {
        const user = await this.AccountService2.me();
        return JSON.parse(JSON.stringify(user));
    }
    get isCurrentPathAvailableInMFE() {
        const isMFEAvailable = this.AI_IS_MFE_ENABLED && this.isReactViewEnabled;
        if (!isMFEAvailable) {
            return false;
        }
        const basepath = `/application/detail/${this.application.shortName}/artificial-intelligence/`;
        const currentPath = this.$location.$$path.replace(basepath, '').split('/')[0];
        const isPathEnabledOnReact = this.listEnabledReactPages.includes(currentPath);
        return isPathEnabledOnReact;
    }
    onFrontendLoad() {
        this.LoadingService.stopLoading();
    }
    onFrontendError() {
        this.LoadingService.stopLoading();
    }
}
AiController.$inject = ['$stateParams', '$scope', '$sce', 'LoadingService', 'AI_FRAME_URL', 'AI_IS_MFE_ENABLED', '$location', 'DEFAULT_FRAGMENT_PREFIX', 'application', 'TenantService', 'TranslateService', 'AccountService2'];
